var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import usePrefixCls from '../hooks/usePrefixCls';
import AntdForm from './original-form';
const Form = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, className } = props, rest = __rest(props, ["prefixCls", "className"]);
    const prefixCls = usePrefixCls('form', customizePrefixCls);
    const mergedClassName = classnames(prefixCls, className);
    return React.createElement(AntdForm, Object.assign({ className: mergedClassName }, rest, { ref: ref }));
});
Form.Item = AntdForm.Item;
Form.List = AntdForm.List;
Form.ErrorList = AntdForm.ErrorList;
Form.useForm = AntdForm.useForm;
Form.Provider = AntdForm.Provider;
Form.displayName = 'Form';
export default Form;
